import { useEffect, useState } from 'react';
import { CorrectionsAPI } from '../../../services/api';

// Correction review (design 2026-10-13 §1 E4): a team member's correction waits
// for the owner; only active corrections reach the AI.
export const CORRECTION_STATUSES = ['pending_review', 'active', 'paused'];

const STATUS_LABELS = {
  pending_review: { zh: '待审核', en: 'Pending review' },
  active: { zh: '生效中', en: 'Active' },
  paused: { zh: '已停用', en: 'Paused' },
};
export const STATUS_COLORS = { pending_review: 'orange', active: 'green', paused: 'gray' };

export const statusLabel = (status, lang = 'zh') => (STATUS_LABELS[status] || STATUS_LABELS.active)[lang === 'zh' ? 'zh' : 'en'];

// Which review buttons the owner sees for a correction in this status.
export const reviewActionsFor = (status) => ({
  pending_review: ['approve', 'pause'],
  active: ['pause'],
  paused: ['resume'],
}[status] || []);

const ACTION_LABELS = {
  approve: { zh: '批准生效', en: 'Approve' },
  pause: { zh: '停用', en: 'Pause' },
  resume: { zh: '恢复生效', en: 'Resume' },
};
export const actionLabel = (action, lang = 'zh') => ACTION_LABELS[action][lang === 'zh' ? 'zh' : 'en'];

export const CORRECTIONS_CHANGED_EVENT = 'aiker:corrections-changed';
export const notifyCorrectionsChanged = () => {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(CORRECTIONS_CHANGED_EVENT));
};

const REFRESH_MS = 60 * 1000;

// Pending-review count for the 纠错记录 menu badge: on load, every minute while
// visible, on focus, and right after a correction changes. Stops on 401/403/404
// (no access, or a backend without review) so it never nags the server.
export const usePendingCorrectionCount = (enabled = true) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) { setCount(0); return undefined; }
    let live = true;
    let stopped = false;
    const refresh = () => {
      if (stopped || (typeof document !== 'undefined' && document.visibilityState === 'hidden')) return;
      Promise.resolve().then(() => CorrectionsAPI.counts())
        .then((data) => { if (live) setCount(Math.max(0, Number(data?.pending_review) || 0)); })
        .catch((error) => {
          if ([401, 403, 404].includes(error?.response?.status)) stopped = true;
        });
    };
    refresh();
    const timer = setInterval(refresh, REFRESH_MS);
    window.addEventListener('focus', refresh);
    window.addEventListener(CORRECTIONS_CHANGED_EVENT, refresh);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(CORRECTIONS_CHANGED_EVENT, refresh);
    };
  }, [enabled]);
  return count;
};
